import Button from '@material-ui/core/Button';
import Table from '@material-ui/core/Table';
import Paper from '@material-ui/core/Paper';
import TableRow from '@material-ui/core/TableRow';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableBody from '@material-ui/core/TableBody';
import { Container } from '@material-ui/core';
import { Link as RouterLink } from 'react-router-dom';
import * as React from 'react';
import { PageHeading } from 'components/PageHeading';

export const AppListView: React.FC<{ list?: any[]; onCreate: any }> = ({ list, onCreate }) => {
    return (
        <Container maxWidth="md">
            <PageHeading title="Apps">
                <Button variant="contained" size="small" color="primary" onClick={onCreate}>
                    + Create app
                </Button>
            </PageHeading>
            <Paper>
                <Table>
                    <TableHead>
                        <TableRow>
                            <TableCell>Name</TableCell>
                            <TableCell>Type</TableCell>
                            <TableCell>Status</TableCell>
                            <TableCell>Installs</TableCell>
                            <TableCell />
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {list?.map(({ node: app }) => (
                            <TableRow key={app.id}>
                                <TableCell>{app.name}</TableCell>
                                <TableCell>{app.type}</TableCell>
                                <TableCell>{app.status}</TableCell>
                                <TableCell>{app.numberOfInstallations}</TableCell>
                                <TableCell>
                                    <Button
                                        to={`/extranet/apps/${app.id}/dashboard`}
                                        variant="outlined"
                                        size="small"
                                        component={RouterLink}
                                    >
                                        Open
                                    </Button>
                                </TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </Paper>
        </Container>
    );
};
